<section class="stylometrics-container">
   <!-- Here goes an idea of  how to display the  summary of  Project Synapse -->
    <section class="project-synapse-summary" *ngIf="isProjectSynapseActive">
      <div class="detection-header">
        <img src="../../../../../../assets/report_v2/detection-ai.svg" alt="">
        <h3>
          {{'stylometrics_component.ai_detection_results' | translate}}
          <img src="../../../../../../assets/report_v2/info-empty.svg" alt="Info" matTooltip="Indicates the likelihood of AI-generated content in the submission and provides a corresponding classification" matTooltipPosition="above" matTooltipClass="new_report_tooltip">
        </h3>
        <div class="similarity-meter">
          <div class="progress-container">
            <div class="progress-bar" [style.width.%]="currentModelComparisonData?.ai_percentage || 0"></div>
          </div>
          <div class="percentage-display">{{ (currentModelComparisonData?.ai_percentage || 0) > 100 ? 100 : (currentModelComparisonData?.ai_percentage || 0).toFixed(2) }} %</div>
        </div>
      </div>

      <div class="classification-banner" [ngClass]="{'low': (currentModelComparisonData?.ai_percentage || 0) <= 20, 'medium': (currentModelComparisonData?.ai_percentage || 0) > 20 && (currentModelComparisonData?.ai_percentage || 0) <= 80, 'high': (currentModelComparisonData?.ai_percentage || 0) > 80}">
        <div class="banner-icon">
          <img src="../../../../../../assets/report_v2/check-circled-filled.svg" alt="Warning" *ngIf="(currentModelComparisonData?.ai_percentage || 0) <= 20">
          <img src="../../../../../../assets/report_v2/warning-triangle-fillled.svg" alt="Warning" *ngIf="(currentModelComparisonData?.ai_percentage || 0) > 20 && (currentModelComparisonData?.ai_percentage || 0) <= 80">
          <img src="../../../../../../assets/report_v2/warning-circled-filled.svg" alt="Warning" *ngIf="(currentModelComparisonData?.ai_percentage || 0) > 80">
        </div>
        <p *ngIf="(currentModelComparisonData?.ai_percentage || 0) <= 20">{{'stylometrics_component_ai.this_content_has_a' | translate}} <strong>{{'stylometrics_component_ai.low_like_lihood' | translate}}</strong> {{'stylometrics_component_ai.written_by_ai' | translate}}</p>
        <p *ngIf="(currentModelComparisonData?.ai_percentage || 0) > 20 && (currentModelComparisonData?.ai_percentage || 0) <= 80">{{'stylometrics_component_ai.this_content_is' | translate}} <strong>{{'stylometrics_component_ai.moderately_likely' | translate}}</strong> {{'stylometrics_component_ai.been_written_by_ai' | translate}}</p>
        <p *ngIf="(currentModelComparisonData?.ai_percentage || 0) > 80">{{'stylometrics_component_ai.this_content_is' | translate}} <strong>{{'stylometrics_component_ai.highly_likely' | translate}}</strong> {{'stylometrics_component_ai.been_written_by_ai' | translate}}</p>
      </div>
      <div class="ai-detection-results">
        <div class="model-information">
          <div class="model-information-header">
            <img src="../../../../../../assets/report_v2/model-info.svg" alt="Model Information">
            <h4>
              {{'stylometrics_component.model_info' | translate}}
              <img src="../../../../../../assets/report_v2/info-empty.svg" alt="Info" [matTooltip]="'stylometrics_component_ai.mattooltip_doc_probability' | translate" matTooltipPosition="above" matTooltipClass="new_report_tooltip">
            </h4>
          </div>
          <div class="model-details">
            <div class="model-item">
              <label>{{'stylometrics_component.most_probable_model' | translate}}</label>
              <span>{{ formatAIModel(mostProbableModel) }}</span>
            </div>
            <div class="model-item">
              <label>{{'stylometrics_component.analysis_date' | translate}}</label>
              <span>{{ formatDate(analysisDate) }}</span>
            </div>
          </div>
        </div>
        <div class="models-select">
          <label for="model-select">{{'stylometrics_component.change_model' | translate}}</label>
          <select id="model-select" (change)="onModelChange($event)">
            <option *ngFor="let model of availableAIModels" [value]="model.value">
              {{ formatAIModel(model.value) }}
            </option>
          </select>
        </div>
      </div>
    </section>
  <!-- Select Comparison Result -->
  <div class="comparison-select" *ngIf="!isProjectSynapseActive">
    <section class="comparison-select-header">
      <label>
        {{'stylometrics_component.select_comparison_result' | translate}}
        <img src="../../../../../../assets/report_v2/info-empty.svg" alt="Info">
      </label>
      <select (change)="onComparisonResultChange($event)">
        <option *ngFor="let submission of availableSubmissions"
                [value]="submission.value">
          {{ submission.title }}
        </option>
      </select>
    </section>
    <section *ngIf="comparisonResult && comparisonResult !== 'none' && !projectSynapse" class="comparison-select-btn">
      <button class="show-submission-button" (click)="showSubmission(comparisonResult)">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2043 8.0922V11.8271C11.2043 12.1572 11.0732 12.4739 10.8397 12.7074C10.6062 12.9409 10.2896 13.072 9.95939 13.072H3.11214C2.78196 13.072 2.4653 12.9409 2.23183 12.7074C1.99835 12.4739 1.86719 12.1572 1.86719 11.8271V4.97982C1.86719 4.64964 1.99835 4.33298 2.23183 4.0995C2.4653 3.86603 2.78196 3.73486 3.11214 3.73486H6.84701" stroke="#0059B3" stroke-width="1.24495" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.33594 1.86743H13.0708V5.6023" stroke="#0059B3" stroke-width="1.24495" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.22656 8.71468L13.0738 1.86743" stroke="#0059B3" stroke-width="1.24495" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{'stylometrics_component.show_submission' | translate}}
      </button>
    </section>
  </div>

  <!-- Stylistic Discrepancy Section -->
  <div class="discrepancy-card" *ngIf="!isProjectSynapseActive">
    <div class="discrepancy-header">
      <div class="header-with-collapse">
        <span>{{'stylometrics_component.stylistic_discrepancy' | translate}}</span>
        <app-severity [severityLevel]="currentSeverity" [text]="currentSeverity | titlecase"></app-severity>
      </div>
      <button class="collapse-button" (click)="toggleCollapse()" [attr.aria-expanded]="!isCollapsed">
        <!-- <span>{{ isCollapsed ? 'Expand' : 'Collapse' }}</span> -->
        <img
          src="../../../../../../assets/report_v2/up_down_arrow.svg"
          [class.rotated]="!isCollapsed" alt="" aria-hidden="true" >
      </button>
    </div>

    <div class="discrepancy-content" [class.collapsed]="isCollapsed">
      <div class="conclusion" [ngClass]="{'high-severity': currentSeverity === 'high', 'medium-severity': currentSeverity === 'medium', 'low-severity': currentSeverity === 'low'}">
        <!-- <img src="../../../../../../assets/report_v2/warning-circled-filled.svg" alt="Warning"> -->
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_137_26568)">
          <path class="color_path" d="M8.3404 16.6454C12.5628 16.6454 15.9858 13.2224 15.9858 9C15.9858 4.77757 12.5628 1.35461 8.3404 1.35461C4.11797 1.35461 0.695007 4.77757 0.695007 9C0.695007 13.2224 4.11797 16.6454 8.3404 16.6454Z" fill="#A50D0D" stroke="#A50D0D" stroke-width="1.04255" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.34045 5.52482V9.69503" stroke="white" stroke-width="1.39007" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.34045 12.4821L8.3474 12.4744" stroke="white" stroke-width="1.39007" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
          <clipPath id="clip0_137_26568">
          <rect width="16.6809" height="16.6809" fill="white" transform="translate(0 0.659573)"/>
          </clipPath>
          </defs>
          </svg>
        <p><strong>{{ 'stylometrics.conclusion' | translate }}</strong> {{ 'stylometrics.conclusion_' + currentSeverity + '_' + (comparisonResult === 'all' ? 'multiple' : 'single') | translate }}</p>
      </div>

      <!-- Graph Legend -->
      <!-- <div class="graph-legend">
        <div class="legend-item">
          <span class="current"></span>
          Current submission
        </div>
        <div class="legend-item">
          <span class="previous"></span>
          AVG. Previous submissions
        </div>
      </div> -->

      <!-- Spider Graph -->
      <div class="chart-container">
        <div class="chart-wrapper">
          <apx-chart
            #chart
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [labels]="chartOptions.labels"
            [plotOptions]="chartOptions.plotOptions"
            [fill]="chartOptions.fill"
            [stroke]="chartOptions.stroke"
            [dataLabels]="chartOptions.dataLabels"
            [legend]="chartOptions.legend"
            [grid]="chartOptions.grid"
            [xaxis]="chartOptions.xaxis"
            [yaxis]="chartOptions.yaxis"
            [colors]="chartOptions.colors"
            [markers]="chartOptions.markers"
          ></apx-chart>
        </div>
      </div>
    </div>
  </div>

  <!-- Analysis Sections -->
  <div class="analysis-sections" *ngIf="currentModelComparisonData?.ai_percentage >= 30">
    <div class="analysis-header-main" *ngIf="isProjectSynapseActive">
      <img src="../../../../../../assets/report_v2/ps_stylometric.svg" alt="Stylometrics">
      <h3>{{'stylometrics_component.stylometrics' | translate}}</h3>
      <img aria-label="Stylometrics info" class="tooltip-icon" src="../../../../../../assets/report_v2/info-empty.svg" alt="Info" [matTooltip]="isProjectSynapseActive ? 'Compares the stylometrics of the current submission to the stylometrics of the selected AI-simulated variant to assess the level of stylistic discrepancy.' : 'Compares the stylometrics of the current submission to the stylometrics of the previous submissions to assess the level of stylistic discrepancy.'" matTooltipPosition="above" matTooltipClass="new_report_tooltip">
      <app-severity [severityLevel]="projectSynapseStylisticDiscrepancy" [text]="(projectSynapseStylisticDiscrepancy | titlecase) + ' Discrepancy'" [reverseColors]="true"></app-severity>
    </div>
    <div class="analysis-item"
         *ngFor="let analysis of analyses"
         [class.active]="isStylometricReportOpen && selectedAnalysis === analysis.id"
         (click)="openAnalysis(analysis)">
      <div class="analysis-header">
        <div class="header-content">
          <div class="header-content">
            <h4>{{analysis.title}}</h4>
            <span class="flag-count" [class.no-flags]="analysis.flagCount === 0">
              {{analysis.flagCount}} {{ analysis.flagCount === 1 ? 'flag' : 'flags' }}
            </span>
          </div>
          <!-- <button class="view-summary">
            {{ activeAnalysis === analysis.type ? 'Hide summary' : 'View summary' }}
            <img
              src="../../../../../../assets/report_v2/up_down_arrow.svg"
              [class.rotated]="activeAnalysis === analysis.type"
              alt="Toggle">
          </button> -->
        </div>
        <div class="header-icon">
          <img [src]="'../../../../../../assets/report_v2/' + analysis.type.toLowerCase() + '_analysis.svg'" [alt]="analysis.type">
          <p>{{ analysis.description }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="stylometric-report-button-container">
    <button class="show-stylometric-report-button" (click)="toggleReportView()">
      {{ (reportType === 'stylometric' || isStylometricReportOpen) ? 'Return to Document View' : 'View Stylometrics Report' }}
    </button>
  </div>
</section>
